
<template>
  <transition name="fade">
    <div
        class="Results"
        :class="{ 'Results--mobile': isMobile }"
    >
      <h2
          v-routing-animation="{speedModifier: 50}"
          class="Results-header">{{ translation.find.result.heading }}</h2>

      <div
          v-routing-animation="{speedModifier: 50, index: 2}"
          class="Results-selection"
          v-if="!isMobile">
        <hempel-selection :selection="selection"/>
      </div>

      <div
          class="FindResult"
          :class="{ 'FindResult--desktop' : !isMobile }"
      >

        <!-- Buckets in rotation -->
        <div
            v-for="(product, index) in results"
            :key="index"

            :data-index="index"
            class="FindResult-bucket"
            :class="{
                        'FindResult-bucket--left': isItemFirst(index),
                        'FindResult-bucket--center': isItemSecond(index),
                        'FindResult-bucket--right': isItemThird(index),
                        'FindResult-bucket--desktop': !isMobile
                    }"
        >
          <transition name="fade">
            <img
                @load="isItemSecond(index) ? mobileSliderContentAdjustment() : null"
                :src="product.img || '/images/placeholder.png'"
                alt="Bucket">
          </transition>
          <div
              v-if="!isItemSecond(index)"
              class="Item-wrapper"
              :class="{ 'FindResult-content--transition': slider.transition }"
          >
            <span class="Item-category">{{ translatePosition(product.position) || 'No position' }}</span>
            <strong class="Item-name">{{ product.name || 'No name' }}</strong>
          </div>
        </div>

        <!-- Controls -->
        <a
            href="#"
            class="FindResult-control FindResult-control--left"
            @click.prevent="moveLeft()"
            :class="{ 'FindResult-control--inactive': !canMoveLeft }">
          <hempel-icon name="arrowLeft"/>
        </a>
        <a
            href="#"
            class="FindResult-control FindResult-control--right"
            @click.prevent="moveRight()"
            :class="{ 'FindResult-control--inactive': !canMoveRight }">
          <hempel-icon name="arrowRight"/>
        </a>

      </div>

      <!-- Focused content -->
      <div
          class="FindResult-content"
          :class="{ 'FindResult-content--desktop': !isMobile }">
        <div class="Result-info">
          <div
              class="Result-transitionWrapper"
              :class="{
                            'Result-transitionWrapper--mobile': isMobile
                    }">

            <transition-group :name="bucketTransitionName">
                            <span
                                key="1"
                                v-if="!slider.transition"
                                class="Result-infoCategory">
                                {{ translatePosition(activeBucket.position) || 'No position' }}
                            </span>
              <strong
                  key="2"
                  v-if="!slider.transition"
                  class="Result-infoName">{{ activeBucket.name || 'No name' }}</strong>
              <small
                  key="3"
                  v-if="!slider.transition"
                  class="Result-infoId">{{ activeBucket.productId || 'No ID' }}</small>

              <ul
                  key="4"
                  v-if="!slider.transition"
                  class="Result-infoFeatures">
                <li
                    class="Result-infoFeature"
                    v-for="(feature, index) in translatedFeatures"
                    :key="index">
                  <hempel-icon name="checkMark"/>
                  {{ feature }}
                </li>
              </ul>

              <ul
                  key="5"
                  class="Result-infoColors"
                  v-if="activeBucket.shades && !slider.transition">
                <li
                    v-for="(color, index) in activeBucket.shades"
                    :key="index">
                                    <span
                                        :style="{ 'background': color }"
                                        :key="index"/>
                </li>
              </ul>

              <p
                  key="6"
                  v-if="!slider.transition && activeNote"
                  class="Result-actionsNote">
                {{ activeNote }}
              </p>
            </transition-group>
          </div>

          <div class="Result-actions">

            <div class="Result-actionsSecondary">
              <hempel-button
                  :url="activeBucket.productUrl"
                  :label="translation.find.result.findOutMore"
                  secondary/>
              <hempel-button
                  @click="openRetailers()"
                  :label="translation.find.result.whereToBuy"
                  secondary
                  v-if="checkPaintLocation()"/>
            </div>

            <hempel-button
                @click="calculate(activeBucket.value)"
                :label="translation.find.result.calculateVolume"
                primary
                small/>
          </div>

          <div class="Result-links">
            <hempel-link
                v-routing-animation="{speedModifier: 50}"
                @click="openOverlay('recommendation')"
                class="Result-link"
                :label="translation.find.result.recommendation.title"
                icon="email"/>
            <hempel-link
                v-routing-animation="{speedModifier: 50}"
                @click="openOverlay('feedback')"
                class="Result-link"
                :label="translation.find.result.feedback.title"
                icon="questionMark"/>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import HempelSelection from '@/views/result/ResultSelection'
import HempelButton from '@/components/shared/button/Button'
import HempelIcon from '@/components/shared/icon/Icon'
import HempelLink from '@/components/shared/link/Link'

const countries = {
  'en-GB': 'UK',
  'en-US': 'US',
  'en-CA': 'US',
  'da-DK': 'Denmark',
  'es-ES': 'Spain',
  'fi-FI': 'Finland',
  'de-DE': 'Germany',
  'el-GR': 'Greece',
  'hr-HR': 'Croatia',
  'it-IT': 'Italy',
  'nb-NO': 'Norway',
  'nl-NL': 'Netherlands',
  'sv-SE_e': 'Sweden - East Coast',
  'sv-SE_w': 'Sweden - West Coast',
  'sv-SE_l': 'Sweden - Lakes',
  'sv-SE': 'Sweden',
  'fr-FR': 'France'
}

export default {
  name: 'HempelFindResults',
  data() {
    return {
      slider: {
        direction: '',
        active: 0,
        transition: false
      }
    }
  },
  beforeMount() {
    this.scrollScreen()
  },
  computed: {
    gaId() {
      let id = ''
      try {
        id = `/?${window.ga.getAll()[0].get('linkerParam')}`
      } catch (e) {}
      return id
    },
    // @TODO: Rewrite this conditional, it's very ugly and not really DRY
    selection() {
      return this.$route.query.waterType
          ? [
            {
              label: this.translation.calculate.result.selection.type,
              value: this.translation.find.answers.type.filter(
                  item => item.value === this.$route.query.type
              )[0].label,
              action: () => {
                this.switchAction(['type'])
              }
            },
            {
              label: this.translation.find.result.selection.waterType,
              value: this.translation.find.answers.waterType.filter(
                  item => item.value === this.$route.query.waterType
              )[0].label,
              action: () => {
                this.switchAction(['waterType'])
              }
            },
            {
              label: this.translation.calculate.result.selection.material,
              value: this.translation.find.answers.material.filter(
                  item => item.value === this.$route.query.material
              )[0].label,
              action: () => {
                this.switchAction(['material'])
              }
            },
            {
              label: this.translation.calculate.result.selection.sailFrequency,
              value: this.translation.find.answers.sailFrequency.filter(
                  item => item.value === this.$route.query.sailFrequency
              )[0].label,
              action: () => {
                this.switchAction(['sailFrequency'])
              }
            },
            {
              label: this.translation.calculate.result.selection.country,
              value: this.translation.find.answers.paintLocation[0].countries.filter(
                  item => item.value === this.$route.query.paintLocation
              )[0].label,
              action: () => {
                this.switchAction(['paintLocation', 'waterType'])
              }
            }
          ].filter(item => item.value)
          : [
            {
              label: this.translation.calculate.result.selection.type,
              value: this.translation.find.answers.type.filter(
                  item => item.value === this.$route.query.type
              )[0].label,
              action: () => {
                this.switchAction(['type'])
              }
            },
            {
              label: this.translation.calculate.result.selection.material,
              value: this.translation.find.answers.material.filter(
                  item => item.value === this.$route.query.material
              )[0].label,
              action: () => {
                this.switchAction(['material'])
              }
            },
            {
              label: this.translation.calculate.result.selection.sailFrequency,
              value: this.translation.find.answers.sailFrequency.filter(
                  item => item.value === this.$route.query.sailFrequency
              )[0].label,
              action: () => {
                this.switchAction(['sailFrequency'])
              }
            },
            {
              label: this.translation.calculate.result.selection.country,
              value: this.translation.find.answers.paintLocation[0].countries.filter(
                  item => item.value === this.$route.query.paintLocation
              )[0].label,
              action: () => {
                this.switchAction(['paintLocation', 'waterType'])
              }
            }
          ].filter(item => item.value)
    },
    products() {
      return this.filterProducts()
    },

    results() {
      const primary = this.products.initialCenter.length > 0 && this.products.initialCenter[0]
      const secondary = this.products.initialLeft.length > 0 && this.products.initialLeft[0]
      const tertiary = this.products.initialRight.length > 0 && this.products.initialRight[0]

      const result = [secondary, tertiary, primary].filter(Boolean)

      // Safety net: never show the same product twice (can happen in edge cases)
      const seen = new Set()
      return result
          .filter(item => {
            const id = item && (item.productId || item.id || item.name)
            if (!id) return true
            if (seen.has(id)) return false
            seen.add(id)
            return true
          })
          .slice(0, 20)
    },
    activeBucket() {
      if (this.results.length > 0) {
        this.dataLayerAdd(
            { type: 'virtualPageview' },
            `/find-product/end/${this.results[this.slider.active].position}/${
                this.results[this.slider.active].name
            }-${this.results[this.slider.active].productId}`
        )
      }
      return this.results[this.slider.active] || {}
    },
    currentFeatures() {
      if (this.currentCountry.length > 0) {
        const tempFeatures = this.$content.hempelProducts.filter(
            product => product.productId === this.activeBucket.productId
        )
        if (tempFeatures.length && tempFeatures[0].hasOwnProperty('keyFeatures')) {
          return tempFeatures
        }
      }
      return []
    },
    translatedFeatures() {
      if (this.currentFeatures.length > 0) {
        const tempFeatures = this.currentFeatures.filter(
            feature => feature[`${this.currentCountry}`] !== undefined
        )
        if (
            tempFeatures.length &&
            tempFeatures[0].hasOwnProperty(`${this.currentCountry}`)
        ) {
          return tempFeatures[0][`${this.currentCountry}`]
        }
        const translatedFeatures = this.activeBucket.keyFeatures
            .filter(kf => kf[this.currentCountry])
            .pop()
        if (translatedFeatures) {
          return translatedFeatures[this.currentCountry]
        }
        return []
      }
      return []
    },
    currentCountry() {
      return countries[this.detectedLanguage]
      const tempCountry = this.translation.find.answers.paintLocation[0].countries.filter(
          country => country.value === `${this.detectedLanguage}`
      )
      return tempCountry[0].label
    },
    canMoveLeft() {
      const prev = (this.slider.active - 1 + 3) % 3
      return this.results[prev] !== undefined
    },
    canMoveRight() {
      const next = (this.slider.active + 1 + 3) % 3
      return this.results[next] !== undefined
    },
    bucketTransitionName() {
      const base = this.isMobile ? 'bucket-insert-mobile-' : 'bucket-insert-'
      return base + (this.slider.direction === 'right' ? 'right' : 'left')
    },
    activeNote() {
      const bucket = this.activeBucket || {}
      const noteObj = bucket.note
      if (!noteObj) return ''

      const cc = this.currentCountry

      if (noteObj[cc]) return noteObj[cc]

      if (/^Sweden\s*-/.test(cc) && noteObj.Sweden) return noteObj.Sweden

      return noteObj.UK || ''
    }
  },
  components: {
    HempelButton,
    HempelIcon,
    HempelLink,
    HempelSelection
  },
  methods: {
    switchAction(ignoreValues) {
      const { query } = this.$route
      ignoreValues = ignoreValues || []
      ignoreValues.forEach(ignoreValue => delete query[ignoreValue])
      this.$router.push({ path: this.$route.path.split('_')[0], query })
    },
    checkPaintLocation() {
      if (this.$route.query.paintLocation == 'el-GR') return false
      return true
    },
    openRetailers() {
      if (this.$route.query.paintLocation == 'da-DK') {
        window.open('https://www.hempelyacht.dk/da-DK/retailers', '_blank')
      }
      if (this.$route.query.paintLocation == 'en-GB') {
        window.open('https://www.hempelyacht.com/en-GB/retailers', '_blank')
      }
      if (this.$route.query.paintLocation == 'en-CA') {
        window.open(
            'https://www.hempelyacht.com/en-us/where-to-buy/canada-retailers',
            '_blank'
        )
      }
      if (this.$route.query.paintLocation == 'es-ES') {
        window.open('https://www.hempelyacht.es/es-ES/retailers', '_blank')
      }
      if (this.$route.query.paintLocation == 'hr-HR') {
        window.open('https://www.hempelyacht.hr/hr-HR/retailers', '_blank')
      }
      if (this.$route.query.paintLocation == 'fi-FI') {
        window.open('https://www.hempelyacht.fi/fi-FI/retailers', '_blank')
      }
      if (this.$route.query.paintLocation == 'de-DE') {
        window.open('https://www.hempelyacht.de/de-DE/retailers', '_blank')
      }
      if (this.$route.query.paintLocation == 'nb-NO') {
        window.open('https://www.hempelyacht.no/nb-NO/retailers', '_blank')
      }
      if (this.$route.query.paintLocation == 'nl-NL') {
        window.open('https://www.hempelyacht.nl/nl-NL/retailers', '_blank')
      }
      if (
          this.$route.query.paintLocation == 'sv-SE_e' ||
          this.$route.query.paintLocation == 'sv-SE_w' ||
          this.$route.query.paintLocation == 'sv-SE_l'
      ) {
        window.open('https://www.hempelyacht.se/sv-SE/retailers', '_blank')
      }
    },
    moveLeft() {
      const prev = (this.slider.active - 1 + 3) % 3

      if (this.canMoveLeft && !this.slider.transition) {
        this.slider.direction = 'left'

        setTimeout(() => {
          this.slider.transition = true
          this.slider.active = prev
        }, 300)

        setTimeout(() => {
          this.slider.transition = false
        }, 1300)
      }
    },
    moveRight() {
      const next = (this.slider.active + 1 + 3) % 3

      if (this.canMoveRight && !this.slider.transition) {
        this.slider.direction = 'right'

        setTimeout(() => {
          this.slider.transition = true
          this.slider.active = next
        }, 300)

        setTimeout(() => {
          this.slider.transition = false
        }, 1300)
      }
    },

    movePrevious() {
      this.slider.active = (this.slider.active - 1 + 3) % 3
    },
    moveNext() {
      this.slider.active = (this.slider.active + 1 + 3) % 3
    },
    isItemFirst(index) {
      return (this.slider.active - 1 + 3) % 3 === index
    },
    isItemSecond(index) {
      return this.slider.active === index
    },
    isItemThird(index) {
      return (this.slider.active + 1 + 3) % 3 === index
    },
    filterProducts() {
      const filter = [{}]
      const { query } = this.$route
      const selected = {
        selectedCountry: countries[query.paintLocation],
        selectedBoatType: query.type,
        selectedMaterial: query.material,
        selectedSailFrequency: query.sailFrequency,
        selectedWaterType:
            query.waterType || (query.paintLocation === 'sv-SE_l' ? 'lakes' : null)
      }
      if (selected.selectedCountry.length === 0) {
        this.errorMessage = 'Please select all filters'
      } else {
        filter[0].countryAllowed = selected.selectedCountry
      }

      if (selected.selectedBoatType.length === 0) {
        this.errorMessage = 'Please select all filters'
      } else {
        filter[0].boatType = selected.selectedBoatType
      }

      if (selected.selectedMaterial.length === 0) {
        this.errorMessage = 'Please select all filters'
      } else {
        filter[0].materialAllowed = selected.selectedMaterial
      }

      if (selected.selectedSailFrequency.length === 0) {
        this.errorMessage = 'Please select all filters'
      } else {
        filter[0].sailFrequency = selected.selectedSailFrequency
      }

      if (
          selected.selectedCountry === 'UK' ||
          selected.selectedCountry === 'Denmark' ||
          selected.selectedCountry === 'Sweden - East Coast' ||
          selected.selectedCountry === 'Sweden - Lakes' ||
          selected.selectedCountry === 'Sweden - West Coast'
      ) {
        switch (selected.selectedWaterType) {
          case 'sea/ocean':
            filter[0].selectedWaterType = 'sea/ocean (Denmark)'
            break
          case 'rivers':
            filter[0].selectedWaterType = 'rivers'
            break
          case 'lakes':
            filter[0].selectedWaterType = 'lakes'
            break
          default:
            filter[0].selectedWaterType = null
            break
        }
      }

      const allFilters = this.hempelFilter(this.getProductsToCalculate, filter)
      return this.filterByPosition(allFilters)
    },
    hempelFilter(products, filters) {
      const filtered = []
      products.filter(product => {
        filters.some(filter => {
          if (
              (filter.countryAllowed === 'Denmark' ||
                  filter.countryAllowed === 'UK' ||
                  filter.countryAllowed === 'Sweden - East Coast' ||
                  filter.countryAllowed === 'Sweden - Lakes' ||
                  filter.countryAllowed === 'Sweden - West Coast') &&
              (product.countryAllowed.includes('Denmark') ||
                  product.countryAllowed.includes('UK') ||
                  product.countryAllowed.includes('Sweden - East Coast') ||
                  product.countryAllowed.includes('Sweden - Lakes') ||
                  product.countryAllowed.includes('Sweden - West Coast'))
          ) {
            if (
                filter.selectedWaterType !== null &&
                product.waterRestrictions.includes(filter.selectedWaterType) &&
                product.countryAllowed.includes(filter.countryAllowed) &&
                product.boatType.includes(filter.boatType) &&
                product.materialAllowed.includes(filter.materialAllowed) &&
                product.sailFrequency.includes(filter.sailFrequency)
            ) {
              filtered.push(product)
              return filtered
            } else if (
                filter.selectedWaterType === null &&
                product.countryAllowed.includes(filter.countryAllowed) &&
                product.boatType.includes(filter.boatType) &&
                product.materialAllowed.includes(filter.materialAllowed) &&
                product.sailFrequency.includes(filter.sailFrequency)
            ) {
              filtered.push(product)
              return filtered
            }
          } else if (
              filter.countryAllowed !== 'Denmark' &&
              filter.countryAllowed !== 'UK' &&
              filter.countryAllowed !== 'Sweden - East Coast' &&
              filter.countryAllowed !== 'Sweden - Lakes' &&
              filter.countryAllowed !== 'Sweden - West Coast'
          ) {
            if (
                product.countryAllowed.includes(filter.countryAllowed) &&
                product.boatType.includes(filter.boatType) &&
                product.materialAllowed.includes(filter.materialAllowed) &&
                product.sailFrequency.includes(filter.sailFrequency)
            ) {
              filtered.push(product)
            }
          }
        })
      })
      return filtered
    },
    filterByPosition(products) {
      const positions = {
        initialLeft: [],
        initialCenter: [],
        initialRight: []
      }

      // Switching positions for Silic One and Hempaspeed only in US/Canada market!
      // NOTE: This MUST be driven by the selected market (paintLocation), not by product.countryAllowed[0],
      // otherwise US/Canada products can end up being pushed into multiple buckets.
      const paintLocation = this.$route.query.paintLocation
      const isUSMarket = paintLocation === 'en-US' || paintLocation === 'en-CA'

      const pushByPosition = product => {
        if (product.position === 'premium' || product.position === 'economic') {
          if (isUSMarket) {
            positions.initialLeft.push(product)
          } else {
            positions.initialCenter.push(product)
          }
          return
        }

        if (product.position === 'alternative' || product.position === 'economic-alternative') {
          if (isUSMarket) {
            positions.initialCenter.push(product)
          } else {
            positions.initialLeft.push(product)
          }
          return
        }

        if (product.position === 'best-buy-alternative' || product.position === 'best-buy') {
          positions.initialRight.push(product)
        }
      }

      products.forEach(pushByPosition)

      this.sortByPriority(positions.initialLeft)
      this.sortByPriority(positions.initialCenter)
      this.sortByPriority(positions.initialRight)

      // Ensure no duplicates inside each bucket (same productId can exist multiple times in the dataset)
      const uniqById = list => {
        const seen = new Set()
        return list.filter(p => {
          const id = (p && (p.productId || p.id || p.name)) || ''
          if (!id) return true
          if (seen.has(id)) return false
          seen.add(id)
          return true
        })
      }

      positions.initialLeft = uniqById(positions.initialLeft)
      positions.initialCenter = uniqById(positions.initialCenter)
      positions.initialRight = uniqById(positions.initialRight)

      return positions
    },
    translatePosition(position) {
      switch (position) {
        case 'best-buy':
          return this.translation.calculate.result.category.bestBuy
        case 'best-buy-alternative':
          return this.translation.calculate.result.category.bestBuyAlternative
        case 'economic-alternative':
          return this.translation.calculate.result.category.economicAlternative
        default:
          return this.translation.calculate.result.category[`${position}`]
      }
    },
    sortByPriority(products) {
      products.sort((productA, productB) => productB.priority - productA.priority)
    },
    calculate(value) {
      this.dataLayerAdd({
        type: 'calculatorEvent',
        category: 'Paint Calculator',
        action: 'Calculate Volume',
        label: `/find-product/end/${this.activeBucket.position}/${this.activeBucket.name}-${
            this.activeBucket.productId
        }`
      })
      this.$router.push({
        path: '/calculate',
        query: Object.assign({}, this.$route.query, { antifouling: value })
      })
    },
    openOverlay(type) {
      switch (type) {
        case 'feedback':
          this.setFeedback(true)
          break
        case 'recommendation':
          const language = 'UK' // this.currentCountry
          const products = this.results.map(product => ({
            id: product.productId,
            title: product.name,
            type: this.capitalizeFirstLetter(product.position || ''),
            image:
                product.img ||
                'http://www.yachtpaintcalculator.com/images/placeholder.png',
            features: product.features.find(
                feature => Object.keys(feature)[0] === language
            )[language],
            colors: product.yachtColorCards
          }))
          this.setRecommendation(products)
          break
        case 'map':
          this.setMap(true)
          break
      }
    },
    goToMap() {
      this.$router.push({
        name: 'map',
        params: { country: this.$route.query.paintLocation }
      })
    },
    scrollScreen() {
      setTimeout(() => {
        this.$scrollTo(`.Header`, this.scrollOptions)
      }, 200)
    },
    mobileSliderContentAdjustment() {
      if (!this.isMobile) {
        return
      }

      const centerBucket = this.$el.querySelector('.FindResult-bucket--center')
      const bucketContent = this.$el.querySelector('.FindResult-content')

      if (!centerBucket || !bucketContent) {
        return
      }

      const centerBucketBoundingBox = centerBucket.getBoundingClientRect()

      console.log(centerBucketBoundingBox)

      // const scale = centerBucketBoundingBox.width / centerBucket.offsetWidth
      // bucketContent.style.top = `${(centerBucket.offsetHeight - centerBucketBoundingBox.top) /
      //     scale}px`
    }
  }
}
</script>